<template>
    <b-container fluid >
        <b-row class="my-4 justify-content-center">
            <router-link :to="$route.path + '/create'">
                <b-btn variant="primary">New client</b-btn>
            </router-link>
        </b-row>
        <b-row v-if="clients">
            <b-col>
                <h1>Klijenti</h1>
                <b-table
                    striped
                    hover
                    :items="clients"
                    :fields="fields"
                    :per-page="perPage"
                    :current-page="currentPage"
                    @row-clicked="goToClient">
                </b-table>
                <b-pagination size="md" align="center" :total-rows="this.clients.length" v-model="currentPage" :per-page="perPage">
                </b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        data() {
            return {
                clients: null,
                currentPage: 1,
                perPage: 10,
                fields: [
                    /*{
                        key: 'id',
                        label: 'No.',
                        sortable: true
                    },*/
                    {
                        key: 'name',
                        label: 'Name',
                        sortable: true
                    },
                    {
                        key: 'owner',
                        label: 'Owner',
                        sortable: true
                    },
                    {
                        key: 'address',
                        label: 'Address',
                        sortable: true
                    },
                    {
                        key: 'contact',
                        label: 'Contact'
                    },
                ]
            }
        },
        methods: {
            goToClient(item) {
                this.$router.push('clients/' + item.id);
            }
        },
        created () {
            adamApi.get(api.clients)
                .then(response => {
                    if (response.status === 200) {
                        this.clients = response.data
                    }
                });
        }
    }
</script>
